import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CountryTradeModel } from 'app/generated/backend/world/api/country-trade-model';

@Injectable()
export class CountryTradeHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
	): Observable<JsonResourceResponse<CountryTradeModel[]>> {
		return this.http.get<JsonResourceResponse<CountryTradeModel[]>>('api/v1/world/countries').pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		CountryTradeHandlerService
	]
})
export class CountryTradeHandlerModule { }
